import type { SVGProps } from "react";
export interface CoinIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CoinIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CoinIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.755 1.298c2.256-.688 4.643-.636 6.193.914l.176.188.069.082 2.559 2.84c1.878 1.924 1.684 4.96.29 7.864-.835 1.74-2.1 3.517-3.72 5.137l-.613.59c-1.45 1.339-3.001 2.398-4.523 3.13-2.905 1.393-5.94 1.587-7.864-.291l-2.84-2.56q-.041-.032-.082-.068l-.188-.176c-1.55-1.55-1.602-3.937-.914-6.193.705-2.309 2.26-4.807 4.455-7.002s4.693-3.75 7.002-4.455M9.54 19.45c-.875.362-1.745.62-2.586.746.728.656 1.998.923 3.757.403zm5.048-3.27a19.6 19.6 0 0 1-2.933 2.194l1.285 1.26a17 17 0 0 0 2.97-2.132zm2.76-12.383c-.678-.67-2-.935-3.937-.344-1.89.577-4.08 1.905-6.067 3.892C5.357 9.33 4.029 11.52 3.452 13.41c-.591 1.936-.326 3.26.344 3.938l.07.063c.432.396 1.083.637 1.998.622.966-.016 2.147-.319 3.432-.936 1.49-.715 3.064-1.824 4.521-3.281s2.566-3.031 3.281-4.52c.617-1.286.92-2.467.936-3.433.015-.888-.212-1.527-.587-1.958l-.098-.11Zm1.025 7.859a19.6 19.6 0 0 1-2.195 2.933l1.323 1.322a17 17 0 0 0 2.131-2.97l-1.26-1.285Zm1.822-4.7c-.126.84-.384 1.71-.746 2.585l1.149 1.171c.52-1.759.253-3.03-.403-3.757Z"
      />
      <path
        fill={color}
        d="M14.37 4.037c.702-.018 1.448.165 2.018.735s.755 1.317.737 2.02c-.018.692-.229 1.42-.54 2.128-.628 1.421-1.77 2.992-3.222 4.443-1.451 1.452-3.022 2.594-4.443 3.221-.708.313-1.437.523-2.128.541-.704.018-1.45-.166-2.02-.737-.57-.57-.754-1.315-.736-2.018.018-.692.228-1.421.54-2.129.628-1.42 1.77-2.993 3.22-4.444 1.452-1.451 3.024-2.593 4.445-3.22.707-.312 1.437-.522 2.128-.54Zm.056 2.248c-.297.008-.726.107-1.277.35-1.097.484-2.443 1.437-3.76 2.754s-2.27 2.664-2.754 3.76c-.243.55-.342.98-.35 1.278-.008.285.068.36.079.37.011.012.085.085.369.078.297-.008.728-.107 1.279-.35 1.096-.484 2.443-1.436 3.76-2.752 1.317-1.317 2.268-2.664 2.752-3.76.244-.552.343-.982.35-1.28.008-.284-.066-.357-.077-.369-.011-.01-.085-.086-.37-.079Z"
      />
    </svg>
  );
}
